import { FabricUser } from 'src/components/bbc-atlaskit-editor';
import { PullRequest } from 'src/components/types';

export const getCurrentUserRole = (
  currentUser?: FabricUser,
  pullRequest?: PullRequest
): string => {
  if (!currentUser || !pullRequest) {
    return 'WATCHER';
  }
  const { author, reviewers } = pullRequest;
  if (currentUser.id === author?.uuid) {
    return 'AUTHOR';
  } else if (reviewers.map(user => user.uuid).includes(currentUser.id)) {
    return 'REVIEWER';
  }
  return 'WATCHER';
};
